var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoCnrs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99.997,
    height: 99.999,
    viewBox: "0 0 79.998 79.999",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h46.941v46.941H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h46.941v46.941H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h46.941v46.941H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.477.04C16.164-.349 10.473 2.116 5.559 7.37c-6.398 6.84-6.277 11.63-4.531 20.207C2.172 33.2 5.508 38.63 10.184 42.47c5.434 4.465 11.816 5.617 18.461 3.324 7.32-2.527 14.324-9.765 17.035-17.598 2.945-8.535.68-16.277-6.219-21.23C33.52 2.7 27.805.368 22.477.04"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h47v47H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h47v47H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v46.941h46.941V0z",
    fill: "url(#d)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14.715 22.301h-1.61l-.003.043c-.012.312-.2 3.05-2.649 3.05-2.191 0-3.3-1.96-3.304-5.831 0-3.871 1.113-5.836 3.304-5.836 2.492 0 2.645 2.926 2.649 3.05l.004.048h1.609a.553.553 0 0 0 .395-.168.482.482 0 0 0 .144-.372c-.035-.757-.422-4.546-4.824-4.546-3.555 0-5.438 2.699-5.438 7.816 0 5.125 1.883 7.832 5.438 7.832 4.234 0 4.762-3.46 4.824-4.52a.537.537 0 0 0-.54-.566",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.074 18.633-1.387-.605c-1.332-.586-1.804-1.157-1.804-2.18 0-1.332.972-2.23 2.425-2.23.86 0 1.563.175 2.422 1.05l.047.05.742-.679c.43-.394.305-.754.125-.984-.722-.852-1.879-1.32-3.265-1.32-2.668 0-4.606 1.742-4.606 4.14 0 2.36 1.489 3.344 3.094 4.059l1.414.633c1.422.636 2.098 1.18 2.098 2.546 0 1.868-1.684 2.364-2.68 2.364-.86 0-1.812-.184-2.984-1.512l-.047-.05-.77.675c-.398.352-.402.648-.015 1.145 1.062 1.367 2.617 1.652 3.738 1.652 2.418 0 4.867-1.485 4.867-4.324 0-2.457-1.363-3.551-3.414-4.43M25.508 16.215c0-2.418-1.96-4.465-4.379-4.465a4.37 4.37 0 0 0-2.95 1.145v-.828h-1.452c-.438 0-.606.285-.606.613v14.098c0 .398.243.61.598.61h1.457V16.3c0-1.457 1.18-2.64 2.637-2.64s2.636 1.183 2.636 2.64v11.09h1.45c.398 0 .609-.222.609-.61V16.217",
    fill: "#63cce1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.023 12.805a.552.552 0 0 0 .125-.344.552.552 0 0 0-.379-.52 4.183 4.183 0 0 0-1.336-.218 4.355 4.355 0 0 0-2.949 1.144v-.828h-1.453c-.442 0-.61.286-.61.614V26.75c0 .398.247.609.602.609h1.453V16.274a2.642 2.642 0 0 1 2.64-2.64c.384 0 .743.085 1.071.23l.84-1.055M21.211 42.641a.393.393 0 0 1-.785 0V16.039a.392.392 0 0 1 .785 0",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    id: "i"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#g"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 29.631,
    gradientTransform: "translate(28.81 17.991)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#476391",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#476390",
    offset: 0.008
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#466290",
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46618f",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45618e",
    offset: 0.043
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44608d",
    offset: 0.055
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#445f8c",
    offset: 0.066
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#435e8b",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#425e8a",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#425d89",
    offset: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#415c88",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#415c88",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#405b87",
    offset: 0.137
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3f5a86",
    offset: 0.148
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3f5985",
    offset: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e5984",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d5883",
    offset: 0.184
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d5782",
    offset: 0.195
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3c5781",
    offset: 0.207
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3c5680",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3b5580",
    offset: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3a547f",
    offset: 0.242
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3a547e",
    offset: 0.254
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39537d",
    offset: 0.262
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39537d",
    offset: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39527c",
    offset: 0.277
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38527c",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38517b",
    offset: 0.293
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37517a",
    offset: 0.301
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37507a",
    offset: 0.309
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#375079",
    offset: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#364f79",
    offset: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#364f78",
    offset: 0.332
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#354f77",
    offset: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#354e77",
    offset: 0.348
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344e76",
    offset: 0.355
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344d76",
    offset: 0.363
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344d75",
    offset: 0.371
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334c74",
    offset: 0.379
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334c74",
    offset: 0.387
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324b73",
    offset: 0.395
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324b73",
    offset: 0.402
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324a72",
    offset: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314a71",
    offset: 0.418
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314971",
    offset: 0.426
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#304970",
    offset: 0.434
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#304870",
    offset: 0.441
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2f486f",
    offset: 0.449
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2f476e",
    offset: 0.457
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2f476e",
    offset: 0.465
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2e466d",
    offset: 0.473
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2e466d",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2d456c",
    offset: 0.488
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2d456b",
    offset: 0.496
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2c446b",
    offset: 0.504
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2c446a",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2b4369",
    offset: 0.527
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2b4268",
    offset: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2a4267",
    offset: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#294166",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#294065",
    offset: 0.574
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283f65",
    offset: 0.586
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283f64",
    offset: 0.598
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273e63",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263d62",
    offset: 0.621
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263d61",
    offset: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253c61",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253c60",
    offset: 0.648
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253b5f",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#243b5f",
    offset: 0.664
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#243a5e",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#233a5e",
    offset: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23395d",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22395c",
    offset: 0.695
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22385c",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22385b",
    offset: 0.711
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21375b",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21375a",
    offset: 0.727
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203659",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203659",
    offset: 0.742
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203658",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1f3557",
    offset: 0.758
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1e3457",
    offset: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1e3356",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1d3355",
    offset: 0.793
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1d3254",
    offset: 0.805
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1c3153",
    offset: 0.816
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1c3153",
    offset: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1b3152",
    offset: 0.832
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1b3051",
    offset: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1a3051",
    offset: 0.848
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1a2f50",
    offset: 0.855
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1a2f50",
    offset: 0.863
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#192e4f",
    offset: 0.871
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#192e4e",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182d4d",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#172c4c",
    offset: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#172b4c",
    offset: 0.914
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#162b4b",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#162b4b",
    offset: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#162a4a",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#152949",
    offset: 0.945
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#152948",
    offset: 0.957
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#142848",
    offset: 0.965
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#142847",
    offset: 0.973
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#132746",
    offset: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#132746",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#122645",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "translate(-.002) scale(1.7042)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#i"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCnrs);
export default __webpack_public_path__ + "static/media/logo-cnrs.0b5ecd70ee75f7c579e07680156f3f37.svg";
export { ForwardRef as ReactComponent };